module.exports = __webpack_public_path__ + "static/darkmode-15723c3038d1d3ad8671642114a7825f.png";